import { IGetAccountListItem } from '@/bundles/Account/types';
import { IFilterSelectedAccount } from '@/bundles/GroupFilters/interfaces/inputs/IFilterSelectedAccount';

export const getAccountMultiplySelectFormattedValue = (value: Array<IFilterSelectedAccount | IGetAccountListItem>): string => {
  return value.map(item => item.name).join(', ');
}
